export const electronicsLevelThree = [
  {
    parentCategoryId: "mobiles",
    categoryId: "mi_mobile",
    level: 3,
    name: "Mi Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "realme_mobile",
    level: 3,
    name: "Realme Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "samsung_mobile",
    level: 3,
    name: "Samsung Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "infinix_mobile",
    level: 3,
    name: "Infinix Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "oppo_mobile",
    level: 3,
    name: "OPPO Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "apple_mobile",
    level: 3,
    name: "Apple Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "vivo_mobile",
    level: 3,
    name: "Vivo Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "honor_mobile",
    level: 3,
    name: "Honor Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "asus_mobile",
    level: 3,
    name: "Asus Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "poco_x2_mobile",
    level: 3,
    name: "Poco X2 Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "realme_narzo_10_mobile",
    level: 3,
    name: "realme Narzo 10 Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "infinix_hot_9_mobile",
    level: 3,
    name: "Infinix Hot 9 Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "iqoo_3_mobile",
    level: 3,
    name: "IQOO 3 Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "iphone_se_mobile",
    level: 3,
    name: "iPhone SE Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "motorola_razr_mobile",
    level: 3,
    name: "Motorola razr Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "realme_narzo_10a_mobile",
    level: 3,
    name: "realme Narzo 10A Mobile",
    parentCategoryName: "Mobiles",
  },
  {
    parentCategoryId: "mobiles",
    categoryId: "motorola_g8_power_lite_mobile",
    level: 3,
    name: "Motorola g8 power lite Mobile",
    parentCategoryName: "Mobiles",
  },

  {
    parentCategoryId: "mobile_accessories",
    categoryId: "mobile_cases",
    level: 3,
    name: "Mobile Cases",
    parentCategoryName: "Mobile Accessories",
  },
  {
    parentCategoryId: "mobile_accessories",
    categoryId: "headphones_headsets",
    level: 3,
    name: "Headphones & Headsets",
    parentCategoryName: "Mobile Accessories",
  },
  {
    parentCategoryId: "mobile_accessories",
    categoryId: "power_banks",
    level: 3,
    name: "Power Banks",
    parentCategoryName: "Mobile Accessories",
  },
  {
    parentCategoryId: "mobile_accessories",
    categoryId: "screenguards",
    level: 3,
    name: "Screenguards",
    parentCategoryName: "Mobile Accessories",
  },
  {
    parentCategoryId: "mobile_accessories",
    categoryId: "memory_cards",
    level: 3,
    name: "Memory Cards",
    parentCategoryName: "Mobile Accessories",
  },
  {
    parentCategoryId: "mobile_accessories",
    categoryId: "smart_headphones",
    level: 3,
    name: "Smart Headphones",
    parentCategoryName: "Mobile Accessories",
  },
  {
    parentCategoryId: "mobile_accessories",
    categoryId: "mobile_cables",
    level: 3,
    name: "Mobile Cables",
    parentCategoryName: "Mobile Accessories",
  },
  {
    parentCategoryId: "mobile_accessories",
    categoryId: "mobile_chargers",
    level: 3,
    name: "Mobile Chargers",
    parentCategoryName: "Mobile Accessories",
  },
  {
    parentCategoryId: "mobile_accessories",
    categoryId: "mobile_holders",
    level: 3,
    name: "Mobile Holders",
    parentCategoryName: "Mobile Accessories",
  },

  {
    parentCategoryId: "smart_wearable_tech",
    categoryId: "smart_watches",
    level: 3,
    name: "Smart Watches",
    parentCategoryName: "Smart Wearable Tech",
  },
  {
    parentCategoryId: "smart_wearable_tech",
    categoryId: "smart_glasses_vr",
    level: 3,
    name: "Smart Glasses (VR)",
    parentCategoryName: "Smart Wearable Tech",
  },
  {
    parentCategoryId: "smart_wearable_tech",
    categoryId: "smart_bands",
    level: 3,
    name: "Smart Bands",
    parentCategoryName: "Smart Wearable Tech",
  },

  {
    parentCategoryId: "health_care_appliances",
    categoryId: "bp_monitors",
    level: 3,
    name: "Bp Monitors",
    parentCategoryName: "Health Care Appliances",
  },
  {
    parentCategoryId: "health_care_appliances",
    categoryId: "weighing_scale",
    level: 3,
    name: "Weighing Scale",
    parentCategoryName: "Health Care Appliances",
  },

  {
    parentCategoryId: "laptops",
    categoryId: "gaming_laptops",
    level: 3,
    name: "Gaming Laptops",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "Office Laptops",
    level: 3,
    name: "Office Laptops",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "desktop_pcs",
    level: 3,
    name: "Desktop PCs",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "gaming_accessories",
    level: 3,
    name: "Gaming & Accessories",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "computer_accessories",
    level: 3,
    name: "Computer Accessories",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "external_hard_disks",
    level: 3,
    name: "External Hard Disks",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "pendrives",
    level: 3,
    name: "Pendrives",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "laptop_skins_decals",
    level: 3,
    name: "Laptop Skins & Decals",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "laptop_bags",
    level: 3,
    name: "Laptop Bags",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "mouse",
    level: 3,
    name: "Mouse",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "computer_peripherals",
    level: 3,
    name: "Computer Peripherals",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "printers_ink_cartridges",
    level: 3,
    name: "Printers & Ink Cartridges",
    parentCategoryName: "Laptops",
  },
  {
    parentCategoryId: "laptops",
    categoryId: "monitors",
    level: 3,
    name: "Monitors",
    parentCategoryName: "Laptops",
  },

  {
    parentCategoryId: "tablets",
    categoryId: "apple_ipads",
    level: 3,
    name: "Apple iPads",
    parentCategoryName: "Tablets",
  },

  {
    parentCategoryId: "speakers",
    categoryId: "home_audio_speakers",
    level: 3,
    name: "Home Audio Speakers",
    parentCategoryName: "Speakers",
  },
  {
    parentCategoryId: "speakers",
    categoryId: "home_theatres",
    level: 3,
    name: "Home Theatres",
    parentCategoryName: "Speakers",
  },
  {
    parentCategoryId: "speakers",
    categoryId: "soundbars",
    level: 3,
    name: "Soundbars",
    parentCategoryName: "Speakers",
  },
  {
    parentCategoryId: "speakers",
    categoryId: "bluetooth_speakers",
    level: 3,
    name: "Bluetooth Speakers",
    parentCategoryName: "Speakers",
  },
  {
    parentCategoryId: "speakers",
    categoryId: "dth_set_top_box",
    level: 3,
    name: "DTH Set Top Box",
    parentCategoryName: "Speakers",
  },

  {
    parentCategoryId: "smart_home_automation",
    categoryId: "google_nest",
    level: 3,
    name: "Google Nest",
    parentCategoryName: "Smart Home Automation",
  },

  {
    parentCategoryId: "camera",
    categoryId: "dslr_mirrorless_camera",
    level: 3,
    name: "DSLR & Mirrorless Camera",
    parentCategoryName: "Camera",
  },
  {
    parentCategoryId: "camera",
    categoryId: "compact_bridge_cameras",
    level: 3,
    name: "Compact & Bridge Cameras",
    parentCategoryName: "Camera",
  },
  {
    parentCategoryId: "camera",
    categoryId: "sports_action_camera",
    level: 3,
    name: "Sports & Action Camera",
    parentCategoryName: "Camera",
  },
  {
    parentCategoryId: "camera",
    categoryId: "camera_accessories",
    level: 3,
    name: "Camera Accessories",
    parentCategoryName: "Camera",
  },
  {
    parentCategoryId: "camera",
    categoryId: "lens",
    level: 3,
    name: "Camera Lens",
    parentCategoryName: "Camera",
  },
  {
    parentCategoryId: "camera",
    categoryId: "camera_tripods",
    level: 3,
    name: "Camera Tripods",
    parentCategoryName: "Camera",
  },

  {
    parentCategoryId: "network_components",
    categoryId: "routers",
    level: 3,
    name: "Routers",
    parentCategoryName: "Network Components",
  },

  {
    parentCategoryId: "featured",
    categoryId: "google_assistant_store",
    level: 3,
    name: "Google Assistant Store",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "laptops_on_buyback_guarantee",
    level: 3,
    name: "Laptops on Buyback Guarantee",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "flipkart_smartbuy",
    level: 3,
    name: "Flipkart SmartBuy",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "li_polymer_power_banks",
    level: 3,
    name: "Li-Polymer Power Banks",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "sony_ps4_pro_slim",
    level: 3,
    name: "Sony PS4 Pro & Slim",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "apple_products",
    level: 3,
    name: "Apple Products",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "microsoft_store",
    level: 3,
    name: "Microsoft Store",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "lenovo_phab_series",
    level: 3,
    name: "Lenovo Phab Series",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "jbl_speakers",
    level: 3,
    name: "JBL Speakers",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "smartphones_on_buyback_guarantee",
    level: 3,
    name: "Smartphones On Buyback Guarantee",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "philips",
    level: 3,
    name: "Philips",
    parentCategoryName: "Featured",
  },
  {
    parentCategoryId: "featured",
    categoryId: "dr_morepen",
    level: 3,
    name: "Dr. Morepen",
    parentCategoryName: "Featured",
  },
];
